import {
  FadvMenuItemCheckbox
} from "./chunk.MPHJUJ6I.js";
import {
  menu_category_styles_default
} from "./chunk.T3AXNH2X.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  hasTag
} from "./chunk.UFU6LZT7.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/menu-item/menu-category.ts
import { t as t2 } from "i18next";
var id = 0;
var FadvMenuCategory = class extends FadvMenuItemCheckbox {
  constructor() {
    super(...arguments);
    this.indeterminate = false;
    this.showCounts = false;
    this.items = "";
    this.componentId = `menu-category-item-${++id}`;
  }
  firstUpdated() {
    super.firstUpdated();
    this.updateStateOfMenuItems(false);
    if (this.label) {
      this.setAttribute("aria-label", this.label);
    } else {
      this.setAttribute("aria-labelledby", `${this.id} ${this.items}`);
    }
  }
  handleClick(event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.updateStateOfMenuItems(true);
  }
  updateStateOfMenuItems(shouldEmit = false) {
    const isChecked = !this.checked;
    let noMenuItemsAreChecked = true;
    let allMenuItemsAreChecked = true;
    let nextElementSibling = this.nextElementSibling;
    let count = 0;
    this.items = "";
    while (nextElementSibling && !hasTag(nextElementSibling, "fadv-menu-category")) {
      if (nextElementSibling.style.display !== "none") {
        const currentElement = nextElementSibling;
        count++;
        if (shouldEmit)
          currentElement.checked = isChecked;
        if (!currentElement.checked) {
          allMenuItemsAreChecked = false;
        } else {
          noMenuItemsAreChecked = false;
        }
        const menuItemId = nextElementSibling.getAttribute("id");
        if (menuItemId)
          this.items += `${menuItemId} `;
      }
      if (shouldEmit)
        emit(this, "sl-select", { detail: { item: nextElementSibling } });
      if (!this.label) {
        this.setAttribute("aria-labelledby", `${this.id} ${this.items}`);
      }
      nextElementSibling = nextElementSibling.nextElementSibling;
    }
    this.count = count;
    this.updateStateOfMenuCategory(allMenuItemsAreChecked, noMenuItemsAreChecked);
  }
  updateStateOfMenuCategory(allMenuItemsAreChecked, noMenuItemsAreChecked) {
    if (allMenuItemsAreChecked) {
      this.checked = true;
      this.indeterminate = false;
    } else if (noMenuItemsAreChecked) {
      this.indeterminate = false;
      this.checked = false;
    } else {
      this.indeterminate = true;
      this.checked = false;
    }
  }
  getRole() {
    return "menuitemcheckbox";
  }
  renderIndeterminate() {
    if (this.checked)
      return w;
    if (!this.indeterminate)
      return w;
    return $`<span part="indeterminate-icon" class="checkbox__icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"><g stroke="currentColor" stroke-width="2"><g transform="translate(2.285714, 6.857143)"><path d="M10.2857143,1.14285714 L1.14285714,1.14285714"></path></g></g></g></svg></span>`;
  }
  renderCount() {
    if (!this.showCounts)
      return w;
    return $`<span class="menu-item__category-count">(${this.count})</span>`;
  }
  render() {
    return $`<div part="base" class=${o({
      "menu-item": true,
      "menu-item--checked": this.checked,
      "menu-item--indeterminate": this.indeterminate,
      "menu-item--disabled": this.disabled,
      "menu-item--has-prefix": this.hasSlot.test("prefix"),
      "menu-item--has-suffix": this.hasSlot.test("suffix")
    })} @click=${this.handleClick} ><span class="menu-item__check">${this.renderChecked()}${this.renderIndeterminate()}</span><span part="label" class="menu-item__label"><fadv-visually-hidden>${t2("components:menu.category")}</fadv-visually-hidden><slot></slot>${this.renderCount()}</span></div>`;
  }
};
FadvMenuCategory.styles = menu_category_styles_default;
__decorateClass([
  t()
], FadvMenuCategory.prototype, "count", 2);
__decorateClass([
  e()
], FadvMenuCategory.prototype, "label", 2);
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvMenuCategory.prototype, "indeterminate", 2);
__decorateClass([
  e({ type: Boolean, attribute: "show-counts" })
], FadvMenuCategory.prototype, "showCounts", 2);
__decorateClass([
  t()
], FadvMenuCategory.prototype, "items", 2);
FadvMenuCategory = __decorateClass([
  n("fadv-menu-category")
], FadvMenuCategory);

export {
  FadvMenuCategory
};
